var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-block-down"},[_c('button',{on:{"click":function($event){return _vm.$emit('on-btn-down')}}},[_c('ArrowDown')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }